import {
  PlannerCurriculum,
  PlannerCurriculumLesson,
  PlannerCurriculumTrack,
  PlannerCurriculumUnit,
} from "@/features/planner/PlannerTypes";

export const findLessonFromPlanId = (
  curriculum: PlannerCurriculum,
  lessonPlanId: string
): {
  curriculum: PlannerCurriculum;
  track: PlannerCurriculumTrack;
  unit: PlannerCurriculumUnit;
  lesson: PlannerCurriculumLesson;
} | null => {
  for (const track of curriculum.tracks) {
    for (const unit of track.units) {
      for (const lesson of unit.lessons) {
        if (lesson.lessonPlanId === lessonPlanId) {
          return {
            curriculum,
            track,
            unit,
            lesson,
          };
        }
      }
    }
  }

  return null;
};
